import { Center, Icon, Menu, TFText, UnstyledButton } from '@tf/ui';
import { S } from '@tf/utils';
import type React from 'react';

export type Priority = 'NO' | 'LOW' | 'MEDIUM' | 'HIGH';

const PRIORITY = {
	NO: 'NO',
	LOW: 'LOW',
	MEDIUM: 'MEDIUM',
	HIGH: 'HIGH',
} as const;

interface Props {
	value?: Priority;
	onChange: (priority: Priority) => void;
}

export const PrioritySelect: React.FC<Props> = ({ value, onChange }) => {
	return (
		<Menu withinPortal styles={{ item: { padding: '.25rem 1rem' } }}>
			<Menu.Target>
				<UnstyledButton
					sx={({ colors }) => ({
						display: 'flex',
						alignItems: 'center',
						width: '4.5rem',
						height: '1.8rem',
						...((!value || value === PRIORITY.NO) && { color: colors.gray[5] }),
						...(value === PRIORITY.LOW && { color: colors.gray[5] }),
						...(value === PRIORITY.MEDIUM && { color: colors.orange[5] }),
						...(value === PRIORITY.HIGH && { color: colors.red[5] }),
					})}
				>
					<Center opacity={0.7} mr=".5rem">
						<Icon.IconCircleFilled size={10} />
					</Center>

					<TFText
						c="dimmed"
						sx={({ colors }) => ({
							flex: 1,
							fontSize: 13,
							'&:hover': { color: colors.brand[6], textDecoration: 'underline' },
							whiteSpace: 'nowrap',
						})}
					>
						{!value || value === PRIORITY.NO ? 'Not set' : S.prettify(value)}
					</TFText>
				</UnstyledButton>
			</Menu.Target>

			<Menu.Dropdown>
				<Menu.Item onClick={() => onChange(PRIORITY.NO)} disabled={value === PRIORITY.NO}>
					<TFText size="sm">No priority</TFText>
				</Menu.Item>
				<Menu.Item onClick={() => onChange(PRIORITY.LOW)} disabled={value === PRIORITY.LOW}>
					<TFText size="sm">{S.prettify(PRIORITY.LOW)}</TFText>
				</Menu.Item>
				<Menu.Item onClick={() => onChange(PRIORITY.MEDIUM)} disabled={value === PRIORITY.MEDIUM}>
					<TFText size="sm">{S.prettify(PRIORITY.MEDIUM)}</TFText>
				</Menu.Item>
				<Menu.Item onClick={() => onChange(PRIORITY.HIGH)} disabled={value === PRIORITY.HIGH}>
					<TFText size="sm">{S.prettify(PRIORITY.HIGH)}</TFText>
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
};
